// extracted by mini-css-extract-plugin
export default {"wrapper":"HttpError_wrapper__gPWtu","code":"HttpError_code__KJCfZ","title":"HttpError_title__nHWpX","link":"HttpError_link__XPVtM"};